import React, { useState, useEffect, useRef } from 'react';
import './AutocompleteInput.css';

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

export const AutocompleteInput = ({
  id,
  name,
  placeholder,
  predefinedOptions = [],
  apiEndpoint,
  onSelect,
  getToken,
  label,
  defaultValue = { label: '', value: '' },
}) => {
  // const [inputValue, setInputValue] = useState('');

  // console.log(`defaultValue=`);
  // console.dir(defaultValue);

  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState('');

  const [suggestions, setSuggestions] = useState(predefinedOptions);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const isManualInput = useRef(true); // 🆕 track input source

  // Debounced fetch
  const fetchSuggestions = debounce(async (keyword) => {
    if (!keyword || keyword.trim() === '') {
      setSuggestions(predefinedOptions);
      return;
    }

    try {
      const response = await fetch(
        `${apiEndpoint}/${encodeURIComponent(keyword)}`,
        {
          headers: {
            Authorization: getToken(),
          },
        },
      );
      if (response.ok && response.status === 200) {
        const data = await response.json();
        setSuggestions(data.length ? data : predefinedOptions);
      }
    } catch (error) {
      console.error('Autocomplete fetch error:', error);
      setSuggestions(predefinedOptions);
    }
  }, 100);

  // Trigger API only if input is typed (not selected)
  useEffect(() => {
    if (!isManualInput.current) {
      isManualInput.current = true; // reset flag
      return;
    }

    if (inputValue.trim() === '') {
      setSuggestions(predefinedOptions);
      return;
    }

    const timer = setTimeout(() => {
      // Fetch api after user stop typing
      isManualInput.current = false;
      fetchSuggestions(inputValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [inputValue]);

  useEffect(() => {
    setSuggestions(predefinedOptions);
  }, [predefinedOptions]);

  return (
    <div style={{ position: 'relative' }}>
      {label && <label>{label}</label>}
      <input
        id={id}
        name={name}
        className='item2 border-none box-size origin-box'
        type='text'
        autoComplete='off'
        value={inputValue}
        placeholder={placeholder}
        onFocus={() => {
          if (inputValue) {
            fetchSuggestions(inputValue.replace(' (All Locations)', ''));
          }

          setTimeout(() => setShowSuggestions(true), 200);
        }}
        onChange={(e) => {
          isManualInput.current = true; // typing input
          setInputValue(e.target.value);
          setShowSuggestions(true);
          onSelect('', '', '');
        }}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
      />
      {showSuggestions && (
        <ul
          className='list-group position-absolute w-30'
          style={{ zIndex: 9999, maxHeight: '200px', overflowY: 'auto' }}
        >
          {suggestions.map((item) => {
            const display = item.label || item.subplacedisplayname;
            const value = item.value || item.subplaceuniqueshortname;
            const parent = item.placeuniqueshortname || item.value;
            return (
              <li
                key={value}
                className='list-group-item list-group-item-action'
                style={{ cursor: 'pointer' }}
                onMouseDown={() => {
                  // 🧠 Prevent API call from useEffect
                  isManualInput.current = false;
                  setInputValue(display);
                  setSelectedValue(value);
                  setShowSuggestions(false);
                  onSelect(value, display, parent);
                }}
              >
                {display}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
